import { CollectionModelFieldLocation, CollectionModelFieldVector } from '@ikegps/core-shared';
import { LocationInputState } from '../../../components/input/location.input.state';
import { addStyles } from '../../../components/theme';
import { TopologicalEditorController } from '../../../page/topological.editor.page';
import { TopologicalPointCollectionCache } from '../../topological.editor.map/point.collection.cache';
import { TopologicalEditorToolController } from '../topological.editor.tool.abstract.ctrl';

const CSS = {
	withRelocationTool: 'c-PoleRelocationTool__attached',
};

const Style = {
	[CSS.withRelocationTool]: {
		cursor: 'crosshair',
	},
};

addStyles(Style);

export class RelocatePoleToolController extends TopologicalEditorToolController {
	locationField: CollectionModelFieldLocation;
	inputState: LocationInputState;

	clickEventListener: google.maps.MapsEventListener;

	constructor(public ctrl: TopologicalEditorController) {
		super(ctrl);

		const editCtrl = ctrl.selectedCollectionEdit;

		this.locationField = editCtrl.collectionEditState.collection.editableLocationField;

		ctrl.classnames.push(CSS.withRelocationTool);
		ctrl.map.map.setOptions({ draggableCursor: 'crosshair' });
		this.makeInputState();
		this.bindMapClickEvent();
	}

	makeInputState() {
		let inputState = this.ctrl.selectedCollectionEdit.changeState.getState(this.locationField.id) as LocationInputState;

		if (!inputState) {
			inputState = new LocationInputState(this.locationField.schema.displayName);

			inputState.onValue(() => {
				this.locationField.Mutator.edited(inputState.value);
			});

			this.topologicalEditorController.selectedCollectionEdit.changeState.addState(this.locationField.id, inputState);

			inputState.setValue(this.locationField.value);
		}
		this.inputState = inputState;
	}

	bindMapClickEvent() {
		this.clickEventListener = this.ctrl.map.map.addListener('click', (event) => {
			const { lat, lng } = event.latLng;

			const newLat = lat().toFixed(7);
			const newLng = lng().toFixed(7);

			this.inputState.latitude.setInputValue(newLat);
			this.inputState.longitude.setInputValue(newLng);

			if (
				this.ctrl.newPoleModel.find(
					(pole) => pole.revision === this.topologicalEditorController.selectedCollectionEdit?.collection?.revision
				)
			) {
				//new poles cannot be span linked!
				this.ctrl.exitTool();
				return;
			}

			const linkedCollectionRevisions = new Set<string>();

			for (const collection of this.ctrl.collectionModels) {
				collection.forEachField((field) => {
					if (
						CollectionModelFieldVector.isVectorField(field) &&
						field.isCollectionLink() &&
						field.getCollections()[0]?.revision === this.ctrl.selectedCollection?.revision
					) {
						linkedCollectionRevisions.add(collection.revision);
					}
				});
			}

			for (const revision of linkedCollectionRevisions) {
				TopologicalPointCollectionCache.dropCollectionVectors(revision);
			}

			TopologicalPointCollectionCache.dropCollectionLocations(this.locationField.collection.revision);

			this.ctrl.updateSpansDistanceBearing(this.locationField.collection.revision);
			this.ctrl.exitTool();
		});
	}

	destroy() {
		this.topologicalEditorController.classnames.filter((x) => x !== CSS.withRelocationTool);

		this.topologicalEditorController.map.map.setOptions({
			draggableCursor: '',
		});

		google.maps.event.removeListener(this.clickEventListener);
	}
}
